import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { FormattedTag, RouteLink } from 'core/components';
import { GAMES_CATEGORY_PAGE } from 'core/constants';
import { GamesCarousel } from 'components/games-carousel/games-carousel';
// import { IconHot } from 'components/icons/icon-hot/icon-hot';

import './logged-in.scss';

export const LoggedIn = ({ games, isUserLoggedIn, isInProgress }) => (
  <>
    <div className="d-flex justify-content-between align-items-center mb-1_75 mb-md-2_5">
      <div className="d-flex align-items-center">
        {/* <IconHot className="most-popular-games-icon" /> */}
        <FormattedTag id="games.most-popular" className="text-large font-weight-bold letter-spacing-default" />
      </div>

      <Button color="link" className="mr-md-12_5 d-flex align-items-center">
        <FormattedTag id="see-all" tag={RouteLink} to={`/category/${GAMES_CATEGORY_PAGE.TOP_GAMES}`} className="text-base" />
      </Button>
    </div>

    <GamesCarousel
      isInProgress={isInProgress}
      isUserLoggedIn={isUserLoggedIn}
      games={games}
      rows={2}
    />
  </>
);

LoggedIn.propTypes = {
  isUserLoggedIn: PropTypes.bool.isRequired,
  isInProgress: PropTypes.bool.isRequired,
  games: PropTypes.arrayOf(PropTypes.shape({})),
};

LoggedIn.defaultProps = {
  games: [],
};
